<template>
  <div class="degree-product">
    <table-list
      title="学历商品列表"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="dataList"
      :columns="columns(this)"
      :operates="operates(this)"
      :btns="btns(this)"
      :options="{ selection: true, operatesWidth: 170 }"
      :pager="pager"
      :tabs-list="tabsList"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <BatchImportModal ref="BatchImportModal" @success="handleBatchImportSuccess"></BatchImportModal>
  </div>
</template>
<script>
const tabsList = [
  {
    prop: 'status',
    activeValue: '',
    children: [
      { value: 1, label: '编辑中' },
      { value: 2, label: '待上架' },
      { value: 3, label: '已上架' },
    ],
  },
]

const btns = _this => [
  {
    label: '创建商品',
    method: _this.handleAdd,
  },
  {
    label: '批量导入商品',
    method: _this.handleBatchImport,
  },
  {
    label: '上架/下架',
    method: _this.handleUp,
  },
  {
    label: '导出',
    method: _this.handleExport,
  },
  {
    label: '删除',
    method: _this.handleDelete,
    type: 'danger',
  },
]

const searchForm = _this => [
  {
    label: '学历类型',
    placeholder: '请选择学历类型',
    type: 'select',
    prop: 'degreeType',
    children: _this.tagTypeList.map(item => ({
      value: item.tagName,
      label: item.tagName,
    })),
  },
  {
    label: '学校',
    placeholder: '请选择学校',
    type: 'select',
    prop: 'schoolName',
    children: _this.schoolList.map(item => ({
      value: item.tagName,
      label: item.tagName,
    })),
  },
  {
    label: '专业名称',
    prop: 'majorName',
    placeholder: '请输入专业名称',
  },
  {
    label: '价格',
    type: 'section',
    propLeft: 'lowPrice',
    propRight: 'highPrice',
  },
  {
    label: '上架时间',
    type: 'picker',
    prop: 'publishTime',
    pickerDate: _this.pickerDate,
  },
]

const columns = () => [
  {
    prop: 'degreeType',
    label: '学历类型',
    minWidth: 80,
  },
  {
    prop: 'schoolName',
    label: '学校名称',
    minWidth: 140,
    twoLines: true,
  },
  {
    prop: 'majorName',
    label: '专业名称',
    minWidth: 140,
    twoLines: true,
  },
  {
    prop: 'studyYears',
    label: '学制年限',
    minWidth: 80,
    formatter: row => {
      return row.studyYears + '年'
    },
  },
  {
    prop: 'price',
    label: '价格',
    minWidth: 100,
    align: 'right',
    sortdata: 1,
  },
  {
    prop: 'sale',
    label: '销量',
    minWidth: 100,
    align: 'right',
    sortdata: 2,
  },
  {
    prop: 'publishUserName',
    label: '发布人',
    minWidth: 100,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 150,
    sortdata: 3,
  },
  {
    prop: 'publishTime',
    label: '上架时间',
    minWidth: 150,
    sortdata: 3,
  },
  {
    prop: 'status',
    label: '状态',
    minWidth: 80,
    render: (h, { row }) => {
      const colorMap = {
        0: '#F67878',
        3: '#5D8BDB',
        4: '#67C23A',
      }
      const labelMap = {
        0: '编辑中',
        3: '待上架',
        4: '已上架',
      }
      return h(
        'span',
        {
          style: {
            color: colorMap[row.status] || '#333333',
            fontWeight: '500',
          },
        },
        labelMap[row.status] || '未知',
      )
    },
  },
]

const operates = _this => [
  {
    label: '发布',
    method: _this.handlePublish,
    isShow: item => item.status == 0,
  },
  {
    label: '编辑',
    method: _this.handleEdit,
    isShow: item => item.status == 0 || item.status == 3,
  },
  {
    label: '销售详情',
    method: _this.handleDetail,
  },
]

import TableList from '@/components/TableList'
import {
  deGreeProductList,
  deGreeSchoolFilter,
  deGreeTypeTagFilter,
  deGreeProductPublish,
  deGreeProductSubmit,
  deGreeProductRemoveCheck,
  deGreeProductBatchDelete,
  deGreeProductListExport,
} from '@/api/center'
import to from 'await-to'
import BatchImportModal from './components/BatchImportModal'
export default {
  name: 'DegreeProduct',
  components: {
    TableList,
    BatchImportModal,
  },
  data() {
    return {
      pickerDate: {
        onPick: ({ minDate }) => {
          this.pickerMinDate = minDate.getTime()
        },
        disabledDate: time => {
          const year = 365 * 24 * 3600 * 1000
          let oneYearLater = this.pickerMinDate + year
          return time.getTime() > oneYearLater
        },
      },
      btns,
      tabsList,
      searchForm,
      columns,
      operates,
      loading: false,
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      dataList: [],
      tagTypeList: [],
      schoolList: [],
      selectList: [],
    }
  },
  mounted() {
    this.handleGetDeGreeTypeList()
    this.getSchoolList()
    this.getList()
  },
  methods: {
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(deGreeProductList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.pager.total = res.data.total
      this.dataList = res.data.list
    },
    async handleGetDeGreeTypeList() {
      const [res, err] = await to(deGreeTypeTagFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.tagTypeList = res.data
    },
    async getSchoolList() {
      const [res, err] = await to(deGreeSchoolFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.schoolList = res.data
    },
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      if (queryParams.publishTime && queryParams.publishTime !== 0) {
        this.queryParams.publishStartTime = queryParams.publishTime[0]
        this.queryParams.publishEndTime = queryParams.publishTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        this.queryParams.publishStartTime = ''
        this.queryParams.publishEndTime = ''
      }
      this.getList()
    },
    handleAdd() {
      this.$router.push('/scenter/degreeProduct/add')
    },
    handleBatchImport() {
      this.$refs.BatchImportModal.show()
    },
    handleBatchImportSuccess() {
      this.getList()
    },
    handleEdit(row) {
      this.$router.push(`/scenter/degreeProduct/edit/${row.productDegreeId}`)
    },
    async handleUp() {
      if (!this.selectList.length) return this.$message.warning('请先选择学历商品')
      let productDegreeIdList = []
      this.selectList.map(v => productDegreeIdList.push(v.productDegreeId))
      const [, err] = await to(deGreeProductPublish({ productDegreeIdList }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('操作成功')
      this.getList()
    },
    async handlePublish({ productDegreeId }) {
      const [, err] = await to(deGreeProductSubmit({ productDegreeId }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('发布成功')
      this.getList()
    },
    async handleDelete() {
      if (!this.selectList.length) return this.$message.warning('请先选择要删除的商品')
      let productDegreeIdList = []
      this.selectList.map(item => productDegreeIdList.push(item.productDegreeId))
      const [res, err] = await to(deGreeProductRemoveCheck({ productDegreeIdList }))
      if (err) return this.$message.warning(err.msg)
      console.log(res)
      if (res.msg === 'success') {
        this.$confirm('您确认删除商品吗?', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const [, error] = await to(deGreeProductBatchDelete({ productDegreeIdList }))
          if (error) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getList()
        })
      } else {
        this.$confirm(res.msg, '确认删除', {
          confirmButtonText: '关闭',
          showConfirmButton: false,
          callback: action => {
            console.log(action)
          },
        })
      }
    },
    async handleExport() {
      let productDegreeIdList = []
      this.selectList.map(v => productDegreeIdList.push(v.productDegreeId))
      const { current, size } = this.pager
      const [res, err] = await to(
        deGreeProductListExport({ current, size, ...this.queryParams, productDegreeIdList }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '学历商品列表.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleDetail(row) {
      this.$router.push({
        path: '/scenter/degreeProduct/saleinfo',
        query: { productId: row.productId },
      })
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>
